/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement Generator
 * Generator für AORV-Angebote
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportSharepointRequest
 */
export interface ExportSharepointRequest {
    /**
     * 
     * @type {string}
     * @memberof ExportSharepointRequest
     */
    machineGroup: string;
}

/**
 * Check if a given object implements the ExportSharepointRequest interface.
 */
export function instanceOfExportSharepointRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "machineGroup" in value;

    return isInstance;
}

export function ExportSharepointRequestFromJSON(json: any): ExportSharepointRequest {
    return ExportSharepointRequestFromJSONTyped(json, false);
}

export function ExportSharepointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportSharepointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'machineGroup': json['machineGroup'],
    };
}

export function ExportSharepointRequestToJSON(value?: ExportSharepointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'machineGroup': value.machineGroup,
    };
}

